import { BelongsToMany, Str, Uid } from 'pinia-orm/dist/decorators'
import Role from 'modules/Role/Role'
import RoleHasPermission from 'modules/RoleHasPermission/RoleHasPermission'
import { Model } from 'pinia-orm'

export default class Permission extends Model {
  static override entity = 'permissions'

  // Fields
  @Uid() declare id: string

  @Str('') declare name: string
  @Str('') declare guard_name: string

  @BelongsToMany(() => Role, () => RoleHasPermission, 'permission_id', 'role_id') declare roles: Role[]
}
